/**
 * Explicit confirmation, in place of window.confirm.
 *
 * The question names the object at stake (docs/15 section 4.4: "the name of
 * the dish on screen"). A destructive confirmation gets the danger button.
 */

import { labels } from '../labels.js';
import { Modal } from './Modal.js';

interface ConfirmDialogProps {
  title: string;
  message?: string;
  confirmLabel?: string;
  cancelLabel?: string;
  destructive?: boolean;
  pending?: boolean;
  onConfirm: () => void;
  onCancel: () => void;
}

export function ConfirmDialog({
  title,
  message,
  confirmLabel = labels.confirm.confirm,
  cancelLabel = labels.confirm.abort,
  destructive = false,
  pending = false,
  onConfirm,
  onCancel,
}: ConfirmDialogProps) {
  return (
    <Modal
      title={title}
      description={message}
      onClose={onCancel}
      locked={pending}
      footer={
        <>
          <button type="button" className="btn-ghost" onClick={onCancel} disabled={pending}>
            {cancelLabel}
          </button>
          <button
            type="button"
            className={destructive ? 'btn-danger btn-danger--solid' : 'btn-primary'}
            onClick={onConfirm}
            disabled={pending}
            autoFocus
          >
            {confirmLabel}
          </button>
        </>
      }
    />
  );
}
